import  { useState, useEffect } from "react";
import { Row, Col, Button, Input } from "reactstrap";
import { FaLink, FaMobile } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getClientImages } from "../../../slices/veloxity/pushNotification/getClientImages";
import phoneScreen from "../../../assets/images/marketing/phoneScreen.png"
import DeeplinkComponent from '../../../components/common/DeeplinkComponent';
import DeeplinkRichComponent from "../../../components/common/DeeplinkRichComponent";
import UrlComponent from '../../../components/common/UrlComponent';
import UrlRichComponent from "../../../components/common/UrlRichComponent";
import TestPushNotificationModal from '../../../components/modal/TestPushNotificationModal';

const AdDesignComponent = ({
    selectedIcon,
    setSelectedIcon,
    selectedOption,
    setSelectedOption,
    updateCampaignData,
    campaignData
}) => {
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(campaignData.selectedFile || null);
    const [selectedButtons, setSelectedButtons] = useState(campaignData.selectedButtons || ['accept']);
    const [isRichNotification, setIsRichNotification] = useState(campaignData.isRichNotification || false);
    const [notificationTitle, setNotificationTitle] = useState(campaignData.notificationTitle || 'Veloxity Notification Title');
    const [notificationBody, setNotificationBody] = useState(campaignData.notificationBody || 'Veloxity Notification Message');
    const [url, setUrl] = useState(campaignData.url || '');
    const [deepLink, setDeepLink] = useState(campaignData.deepLink || '');
    const [selectedLanguage, setSelectedLanguage] = useState(campaignData.selectedLanguage || null);
    const [modalOpenTestPN, setModalOpenTestPN] = useState(false);
    const [imageUrl, setImageUrl] = useState(campaignData.imageUrl || '');

    const { uploadedImage = null, loading: uploadLoading = false } = useSelector((state) => state.uploadImage || {});

    const getOfferType = () => {
        if (selectedOption === 'url') {
            return 'URL';
        } else if (selectedOption === 'deeplink') {
            return 'DEEP_LINK';
        }
        return null;
    };

    const getPnType = () => {
        return isRichNotification ? 'RICH_NOTIFICATION' : 'SMART_PN';
    };

    useEffect(() => {
        dispatch(getClientImages());
    }, [dispatch]);

    useEffect(() => {
        if (uploadedImage) {
            setImageUrl(uploadedImage.url);
            updateCampaignData({ imageUrl: uploadedImage.url });
        }
    }, [uploadedImage, updateCampaignData]);

    useEffect(() => {
        updateCampaignData({
            selectedOption,
            offerType: getOfferType(),
            pnType: getPnType(),
            isRichNotification,
            selectedFile,
            selectedButtons,
            notificationTitle,
            notificationBody,
            url,
            deepLink,
            selectedLanguage,
            imageUrl
        });
    }, [
        selectedOption, 
        isRichNotification, 
        selectedFile, 
        selectedButtons, 
        notificationTitle, 
        notificationBody, 
        url, 
        deepLink, 
        selectedLanguage, 
        imageUrl,
        updateCampaignData
    ]);

    const toggleModalTestPN = () => setModalOpenTestPN(!modalOpenTestPN);

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            const file = e.target.files[0];
            setSelectedFile(file);
            updateCampaignData({ selectedFile: file });
        }
    };

    const toggleButtonSelection = (button) => {
        if (selectedButtons.includes(button)) {
            if (button !== 'accept') {
                setSelectedButtons(selectedButtons.filter(b => b !== button));
                
                if (typeof updateCampaignData === 'function') {
                    updateCampaignData({ disableCancel: true });
                }
            }
        } else {
            setSelectedButtons([...selectedButtons, button]);
            
            if (typeof updateCampaignData === 'function') {
                updateCampaignData({ disableCancel: false });
            }
        }
    };

    const handleToggle = () => {
        const newRichStatus = !isRichNotification;
        setIsRichNotification(newRichStatus);
        
        updateCampaignData({
            isRichNotification: newRichStatus,
            url: url,
            deepLink: deepLink,
            pnType: newRichStatus ? 'RICH_NOTIFICATION' : 'SMART_PN'
        });
    };

    const handleUrlChange = (e) => {
        setUrl(e.target.value);
    };

    const handleDeepLinkChange = (e) => {
        setDeepLink(e.target.value);
    };


    const handleUpdateCampaignData = (data) => {
        if (typeof data === 'object') {
            if (data.imageUrl) {
                setImageUrl(data.imageUrl);
            }
            
            if (typeof updateCampaignData === 'function') {
                updateCampaignData(data);
            }
        } 
        else if (typeof data === 'string' && arguments.length > 1) {
            const key = data;
            const value = arguments[1];
            
            if (key === 'imageUrl') {
                setImageUrl(value);
            }
            
            if (typeof updateCampaignData === 'function') {
                const updateData = {};
                updateData[key] = value;
                updateCampaignData(updateData);
            }
        }
    };

    return (
        selectedIcon === 2 && (
            <div style={{padding: '2% 5%'}}>
                <Row style={{marginBottom: "35px"}}>
                    <Col lg={2}>
                        <Button className={`btn-custom-size ${selectedOption === 'url' ? 'active' : ''}`} outline
                                onClick={() => setSelectedOption('url')}>
                            <FaLink style={{width: "30px"}}/>
                            <span style={{fontSize: "15px"}}>Url</span>
                        </Button>
                    </Col>
                    <Col lg={2}>
                        <Button className={`btn-custom-size ${selectedOption === 'deeplink' ? 'active' : ''}`} outline
                                onClick={() => setSelectedOption('deeplink')}>
                            <FaMobile style={{width: "20px"}}/>
                            <span style={{fontSize: "15px"}}>Deeplink</span>
                        </Button>
                    </Col>
                    <Col lg={2}>
                    </Col>
                    <Col lg={1}>
                    </Col>
                    <Col lg={4}>
                        <div className="btn-custom-size-double">
                            <h4 className="btn-title">Test Push Notification</h4>
                            <button className="btn-select-device" onClick={toggleModalTestPN}>
                                Select Device
                            </button>
                        </div>
                    </Col>
                </Row>

                <TestPushNotificationModal
                    isOpen={modalOpenTestPN}
                    toggleModalTestPN={toggleModalTestPN}
                />

                {(selectedOption === 'url' || selectedOption === 'deeplink') && (
                    <Row
                        style={{backgroundColor: '#f5f5f5', padding: '10px', alignItems: 'center', marginRight: '25%'}}>
                        <Col md={8} style={{textAlign: 'left'}}>
                            <h2 style={{marginBottom: '0'}}>Design Your Ad</h2>
                        </Col>
                        <Col md={4} className="d-flex justify-content-end">
                            <span style={{paddingTop: '5px', fontSize: '15px'}}>Rich Notification</span>
                            <button onClick={handleToggle} style={{
                                marginLeft: '10px',
                                marginTop: '5px',
                                backgroundColor: isRichNotification ? '#CC1977' : 'grey',
                                border: 'none',
                                borderRadius: '15px',
                                width: '40px',
                                height: '20px',
                                position: 'relative',
                            }}>
                                <div style={{
                                    width: '20px',
                                    height: '20px',
                                    backgroundColor: '#FFF',
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    top: '0',
                                    left: isRichNotification ? '20px' : '0',
                                    transition: 'left 0.3s'
                                }}/>
                            </button>
                        </Col>
                    </Row>
                )}

                {selectedOption === 'url' && !isRichNotification && (
                    <UrlComponent
                        selectedButtons={selectedButtons}
                        toggleButtonSelection={toggleButtonSelection}
                        setSelectedIcon={setSelectedIcon}
                        phoneScreen={phoneScreen}
                        isRichNotification={isRichNotification}
                        selectedFile={selectedFile}
                        handleFileChange={handleFileChange}
                        url={url}
                        handleUrlChange={handleUrlChange}
                        uploadLoading={uploadLoading}
                        imageUrl={imageUrl}
                        updateCampaignData={handleUpdateCampaignData}
                    />
                )}

                {isRichNotification && selectedOption === 'url' && (
                    <UrlRichComponent
                        handleFileChange={handleFileChange}
                        selectedButtons={selectedButtons}
                        toggleButtonSelection={toggleButtonSelection}
                        setSelectedIcon={setSelectedIcon}
                        phoneScreen={phoneScreen}
                        notificationTitle={notificationTitle}
                        setNotificationTitle={setNotificationTitle}
                        notificationBody={notificationBody}
                        setNotificationBody={setNotificationBody}
                        selectedFile={selectedFile}
                        url={url}
                        handleUrlChange={handleUrlChange}
                        uploadLoading={uploadLoading}
                        imageUrl={imageUrl}
                        updateCampaignData={handleUpdateCampaignData}
                    />
                )}

                {selectedOption === 'deeplink' && !isRichNotification && (
                    <DeeplinkComponent
                        selectedFile={selectedFile}
                        selectedButtons={selectedButtons}
                        setSelectedIcon={setSelectedIcon}
                        toggleButtonSelection={toggleButtonSelection}
                        phoneScreen={phoneScreen}
                        isRichNotification={isRichNotification}
                        handleFileChange={handleFileChange}
                        deepLink={deepLink}
                        handleDeepLinkChange={handleDeepLinkChange}
                        uploadLoading={uploadLoading}
                        imageUrl={imageUrl}
                        updateCampaignData={handleUpdateCampaignData}
                    />
                )}
                
                {selectedOption === 'deeplink' && isRichNotification && (
                    <DeeplinkRichComponent
                        handleFileChange={handleFileChange}
                        selectedButtons={selectedButtons}
                        toggleButtonSelection={toggleButtonSelection}
                        setSelectedIcon={setSelectedIcon}
                        phoneScreen={phoneScreen}
                        notificationTitle={notificationTitle}
                        setNotificationTitle={setNotificationTitle}
                        notificationBody={notificationBody}
                        setNotificationBody={setNotificationBody}
                        selectedFile={selectedFile}
                        deepLink={deepLink}
                        handleDeepLinkChange={handleDeepLinkChange}
                        uploadLoading={uploadLoading}
                        imageUrl={imageUrl}
                        updateCampaignData={handleUpdateCampaignData}
                    />
                )}
                {selectedOption === 'sms' && (
                    <div>
                        <h5>SMS Settings</h5>
                        <Input type="text" placeholder="Enter your SMS content"/>
                    </div>
                )}
                {selectedOption === 'call' && (
                    <div>
                        <h5>CAll Settings</h5>
                        <Input type="text" placeholder="Enter your call content"/>
                    </div>
                )}
                {selectedOption === 'map' && (
                    <div>
                        <h5>Map Settings</h5>
                        <Input type="text" placeholder="Enter your call content"/>
                    </div>
                )}
                {selectedOption === 'thirdParty' && (
                    <div>
                        <h5>3rd Party Growth Settings</h5>
                        <Input type="text" placeholder="Enter your call content"/>
                    </div>
                )}
            </div>
        )
    );
}

export default AdDesignComponent;
